import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import { api_gateway } from '../../../../conexoes/api.js'
import '../../../../css/painelAdministrativo/pavUsuario/pavUsuario.css'
import iconeGerarSenha from '../../../../icones/gerar-senha.svg'
import fechar from '../../../../icones/iconesVersaoEscura/fechar_janela.svg'
import ellipseVerde from '../../../../icones/iconesVersaoVerde/ellipse.svg'
import {
  revelarEditarUsuario,
  revelarNovoUsuario
} from '../../../../redux/actions/index'
import { useGlobal } from '../../../../stores/useGlobal.js'
import {
  olhoDesligado,
  olhoLigado
} from '../../../../utils/alternanciaIcones.js'
import decryptJWT from '../../../../utils/decryptJWT.js'
import ColetaClickstream from '../../../clickstreamAnalise/clickstreamColeta.js'
import MensagemErro from '../../../componentesModais/mensagens/mensagemErro.js'
import MensagemSucesso from '../../../componentesModais/mensagens/mensagemSucesso.js'
import Banner from '../../../Mantine/Banner'
import Checkbox from '../../../Mantine/Checkbox'
import Switch from '../../../Mantine/Switch/index.jsx'

import * as S from './styles.js'

const BLOCKED_TYPES = {
  UNBLOCKED: 1,
  CUSTOMER_SOLICITATION: 4
}

function gerarSenhaAleatoria() {
  const letrasMaiusculas = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const letrasMinusculas = 'abcdefghijklmnopqrstuvwxyz'
  const numeros = '0123456789'
  const caracteresEspeciais = '!@#$%^&*()_+{}[]:;,.?~\\-|<>='

  const todosCaracteres =
    letrasMaiusculas + letrasMinusculas + numeros + caracteresEspeciais

  const gerarCaracter = (grupo) =>
    grupo.charAt(Math.floor(Math.random() * grupo.length))

  let senha = [
    gerarCaracter(letrasMaiusculas),
    gerarCaracter(numeros),
    gerarCaracter(letrasMinusculas),
    gerarCaracter(caracteresEspeciais)
  ]

  for (let i = senha.length; i <= 11; i++) {
    senha.push(
      todosCaracteres.charAt(Math.floor(Math.random() * todosCaracteres.length))
    )
  }

  return senha.join('')
}

export default function CadastroUsuario({
  usuarioSelecionado,
  tituloJanela,
  onFinish
}) {
  const { setIsLoadingGlobal, setMostrarNotificacao } = useGlobal()
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [mostrarSenha, setMostrarSenha] = useState('password')
  const [userBlocked, setUserBlocked] = useState(
    usuarioSelecionado?.usuario_bloqueio !== BLOCKED_TYPES.UNBLOCKED
  )
  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [permissoes, setPermissoes] = useState({
    receberEmails: false,
    visualizarTodosClientes: false,
    enviarSmsForaParque: false
  })
  const [blocked, setBlocked] = useState(
    usuarioSelecionado.usuario_bloqueio !== BLOCKED_TYPES.UNBLOCKED
  )
  const [bloqueioMotivoUpdated, setBloqueioMotivoUpdated] = useState(
    usuarioSelecionado.bloqueio_motivo
  )
  const [cdBloqueio, setCdBloqueio] = useState(
    usuarioSelecionado.usuario_bloqueio
  )
  const [flAtivo, setFlAtivo] = useState(false)

  const isVendedor = !!usuarioSelecionado.cd_vendedor
  const isEditar = tituloJanela === 'Editar'
  const phMensagemSucesso = isEditar ? 'editado' : 'cadastrado'

  const despacho = useDispatch()

  const {
    setValue,
    register,
    handleSubmit,
    reset,
    watch,
    formState: { dirty }
  } = useForm()

  const {
    dsCliente,
    cdCliente,
    cdUsuario,
    dsUsuario,
    dsEmail,
    dsSobrenome,
    dsTelefone,
    cdBloqueioStatus
  } = watch([
    'dsCliente',
    'cdCliente',
    'cdUsuario',
    'dsUsuario',
    'dsEmail',
    'dsSobrenome',
    'dsTelefone',
    'cdBloqueioStatus'
  ])

  const isBloqueioInatividade = cdBloqueioStatus === 2
  const mudarBorderRadius =
    !flAtivo &&
    cdBloqueioStatus !== BLOCKED_TYPES.UNBLOCKED &&
    !isBloqueioInatividade

  useEffect(() => {
    setIsLoadingGlobal(true)

    if (isEditar) {
      const {
        ds_pav_cliente: dsCliente,
        cd_pav_cliente: cdCliente,
        cd_pav_usuario: cdUsuario,
        ds_pav_usuario: dsUsuario,
        ds_email: dsEmail,
        ds_pav_usuario_sobrenome: dsSobrenome,
        usuario_bloqueio: cdBloqueioStatus,
        ds_telefone: dsTelefone,
        fl_ativo: flAtivo,
        fl_vendedor_email: receberEmails,
        fl_vendedor_todos_clientes: visualizarTodosClientes,
        fl_enviar_fora_parque: enviarSmsForaParque
      } = usuarioSelecionado

      reset({
        dsCliente,
        cdCliente,
        cdUsuario,
        dsUsuario,
        dsEmail,
        dsSobrenome,
        cdBloqueioStatus,
        dsTelefone
      })

      setFlAtivo(flAtivo)
      setPermissoes({
        receberEmails: !!receberEmails,
        visualizarTodosClientes: !!visualizarTodosClientes,
        enviarSmsForaParque: !!enviarSmsForaParque
      })
    }

    setIsLoadingGlobal(false)
  }, [tituloJanela, usuarioSelecionado, reset, isEditar, setIsLoadingGlobal])

  function handleSalvar(data) {
    if (tituloJanela === 'Cadastrar') {
      ColetaClickstream(1373)
      handleCadastrar(data)
    } else {
      ColetaClickstream(1374)
      handleAlterar(data)
    }
  }

  async function handleAlterar(data) {
    const camposAlterados = {}

    if (usuarioSelecionado.ds_pav_usuario !== dsUsuario) {
      camposAlterados.ds_pav_usuario = dsUsuario
    }

    if (usuarioSelecionado.ds_pav_usuario_sobrenome !== dsSobrenome) {
      camposAlterados.ds_pav_usuario_sobrenome = dsSobrenome
    }

    if (usuarioSelecionado.ds_telefone !== dsTelefone) {
      camposAlterados.ds_telefone = dsTelefone
    }

    if (usuarioSelecionado.ds_email !== dsEmail) {
      camposAlterados.ds_email = dsEmail
    }

    if (data.dsSenha) {
      camposAlterados.ds_senha = data.dsSenha
      camposAlterados.fl_padrao_senha = 1
    }

    if (cdBloqueio !== cdBloqueioStatus) {
      camposAlterados.cd_pav_usuario_bloqueio_status = cdBloqueio
    }

    camposAlterados.fl_vendedor_email = permissoes.receberEmails ? 1 : 0
    camposAlterados.fl_vendedor_todos_clientes =
      permissoes.visualizarTodosClientes ? 1 : 0
    camposAlterados.fl_enviar_fora_parque = permissoes.enviarSmsForaParque
      ? 1
      : 0

    setIsLoadingGlobal(true)
    const payload = {
      dados: {
        cd_pav_cliente: cdCliente,
        fl_ativo: flAtivo ? 1 : 0,
        cd_pav_usuario_updated: decryptJWT('codigo'),
        ...camposAlterados,
        ...(blocked &&
          flAtivo && {
            cd_pav_usuario_bloqueio_status: 1,
            n0_tentativas_login: 0
          })
      },
      condicao: {
        cd_pav_usuario: cdUsuario,
        cd_sms_usuario: usuarioSelecionado.cd_sms_usuario,
        ...(isVendedor && {
          cd_vendedor: usuarioSelecionado.cd_vendedor
        })
      }
    }

    await api_gateway
      .post('/m1/alterar/usuario', payload)
      .then(() => {
        setRevelarMensagemSucesso(true)
      })
      .catch((error) => {
        setMensagemErro(error.response.data.info)
        setRevelarMensagemErro(true)
      })
      .finally(() => setIsLoadingGlobal(false))
  }

  async function handleCadastrar(data) {
    setIsLoadingGlobal(true)

    const payload = {
      ds_pav_usuario: data.dsUsuario.trim(),
      ds_email: data.dsEmail.trim(),
      ds_senha: data.dsSenha,
      cd_pav_cliente: cdCliente,
      ds_telefone: data.dsTelefone.trim(),
      ds_pav_usuario_sobrenome: data.dsSobrenome.trim(),
      cd_pav_usuario_created: decryptJWT('codigo'),
      fl_ativo: flAtivo ? 1 : 0
    }

    await api_gateway
      .post('/m1/cadastrar/usuario', payload)
      .then(() => {
        setRevelarMensagemSucesso(true)
      })
      .catch((error) => {
        setIsLoadingGlobal(false)
        setMensagemErro(error.response.data.info)
        setRevelarMensagemErro(true)
      })
      .finally(() => setIsLoadingGlobal(false))
  }

  function handleCancelar() {
    ColetaClickstream(1372) // dropAcoesRevelarNovoUsuarioCancelar
    setRevelarMensagemSucesso(false)
    setRevelarMensagemErro(false)
    despacho(revelarNovoUsuario(false))
    despacho(revelarEditarUsuario(false))
  }

  const exibirIcone = useMemo(() => {
    return mostrarSenha === 'password' ? (
      <img src={olhoDesligado()} alt="olho desligado" />
    ) : (
      <img src={olhoLigado()} alt="olho ligado" />
    )
  }, [mostrarSenha])

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  function handleMensagemSucesso(confirmacao) {
    if (!revelarMensagemSucesso) {
      setRevelarMensagemSucesso(true)
    } else {
      usuarioSelecionado.fl_ativo = flAtivo
      usuarioSelecionado.usuario_bloqueio = cdBloqueio
      usuarioSelecionado.bloqueio_motivo =
        cdBloqueio !== BLOCKED_TYPES.UNBLOCKED ? bloqueioMotivoUpdated : ''

      setRevelarMensagemSucesso(false)
      handleCancelar()
    }

    if (confirmacao) {
      onFinish()
    }
  }

  const handleGerarSenha = () => {
    const senha = gerarSenhaAleatoria()
    setValue('dsSenha', senha)
    setFlAtivo(true)

    setUserBlocked(false)

    navigator.clipboard.writeText(senha).then(() => {
      setMostrarNotificacao({
        show: true,
        type: 'success',
        title: 'Senha copiada',
        message: 'A senha foi gerada e copiada para a área de transferência.',
        autoHide: 5000
      })
    })
  }

  const handleSwitchChange = (event) => {
    if (usuarioSelecionado.usuario_bloqueio && flAtivo) {
      setBlocked(true)
      setUserBlocked(true)
      setCdBloqueio(BLOCKED_TYPES.CUSTOMER_SOLICITATION)
      setBloqueioMotivoUpdated('Bloqueio por solicitação do cliente')
    } else {
      setCdBloqueio(BLOCKED_TYPES.UNBLOCKED)
      setBloqueioMotivoUpdated('')
    }
    if (blocked) setUserBlocked(!event.currentTarget.checked)
    setFlAtivo(event.currentTarget.checked)

    if (!event.currentTarget.checked) setValue('dsSenha', undefined)
  }

  const handleVerSenha = () =>
    setMostrarSenha((prev) => (prev === 'password' ? 'text' : 'password'))

  const handleChange = useCallback(
    (checked, key) => {
      setPermissoes((prev) => ({
        ...prev,
        [key]: checked
      }))
    },
    [setPermissoes]
  )

  const habilitarConfirmar = useMemo(() => {
    const alterouPermissoes =
      permissoes.receberEmails !== !!usuarioSelecionado.fl_vendedor_email ||
      permissoes.visualizarTodosClientes !==
        !!usuarioSelecionado.fl_vendedor_todos_clientes ||
      permissoes.enviarSmsForaParque !==
        !!usuarioSelecionado.fl_enviar_fora_parque

    const alterouStatus = !!usuarioSelecionado.fl_ativo !== !!flAtivo

    return alterouPermissoes || alterouStatus || dirty
  }, [permissoes, usuarioSelecionado, flAtivo, dirty])

  return (
    <S.Overalay>
      <S.Modal>
        <S.TituloWrapper>
          <S.Elipse src={ellipseVerde} alt="elipse" />
          <S.TituloModal> {tituloJanela} usuário</S.TituloModal>
          <S.BotaoFechar onClick={handleCancelar}>
            <img
              className="botao-fechar-janela-icone"
              src={fechar}
              alt="fechar-janela"
            />
          </S.BotaoFechar>
        </S.TituloWrapper>
        {userBlocked && (
          <S.BannerWrapper>
            <Banner
              title="Motivo da inatividade: Bloqueio"
              type={isBloqueioInatividade ? 'warning' : 'error'}
            >
              {bloqueioMotivoUpdated}.
            </Banner>
          </S.BannerWrapper>
        )}
        <S.Form onSubmit={handleSubmit(handleSalvar)}>
          <S.GrupoInput>
            <S.LabelDefault>Cliente</S.LabelDefault>
            <S.ClienteSelecionado>{dsCliente}</S.ClienteSelecionado>
          </S.GrupoInput>
          <S.Linha>
            <S.GrupoInput>
              <S.InputLabel for="dsUsuario">
                Nome<S.Required>*</S.Required>
              </S.InputLabel>
              <S.Input
                id="dsUsuario"
                autocomplete="off"
                name="dsUsuario"
                type="text"
                placeholder="Insira o nome"
                maxlength={100}
                ref={register({
                  validate: { minimo: (value) => value.length > 1 }
                })}
              />
            </S.GrupoInput>
            <S.GrupoInput>
              <S.InputLabel for="dsSobrenome">Sobrenome</S.InputLabel>
              <S.Input
                autoComplete="off"
                id="dsSobrenome"
                name="dsSobrenome"
                type="text"
                placeholder="Insira o sobrenome"
                maxLength={100}
                ref={register({
                  required: !isEditar ? 'Sobrenome é obrigatório' : false,
                  validate: (value) => {
                    if (value && value.length <= 1) {
                      return 'Mínimo de 2 caracteres'
                    }
                    return true
                  }
                })}
              />
            </S.GrupoInput>
          </S.Linha>
          <S.Linha>
            <S.GrupoInput>
              <S.InputLabel for="dsTelefone">Telefone</S.InputLabel>
              <S.Input
                id="dsTelefone"
                name="dsTelefone"
                type="text"
                placeholder="Insira o telefone"
                minLength={11}
                maxlength={11}
                ref={register({
                  required: !isEditar ? 'Telefone é obrigatório' : false,
                  validate: !isEditar
                    ? {
                        minimo: (value) =>
                          value.length >= 11 || 'Mínimo de 11 caracteres',
                        maximo: (value) =>
                          value.length <= 11 || 'Máximo de 11 caracteres'
                      }
                    : undefined
                })}
              />
            </S.GrupoInput>
            <S.GrupoInput>
              <S.InputLabel for="dsEmail">
                E-mail
                <S.Required>*</S.Required>
              </S.InputLabel>
              <S.Input
                id="dsEmail"
                name="dsEmail"
                type="text"
                placeholder="Insira o e-mail"
                maxlength={100}
                ref={register({
                  validate: {
                    minimo: (value) =>
                      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) === true
                  }
                })}
              />
            </S.GrupoInput>
          </S.Linha>
          <S.Aviso>
            <S.Required> * </S.Required>Campos obrigatórios
          </S.Aviso>
          <S.Divisor />
          <S.TituloStatus>Status do usuário</S.TituloStatus>
          <S.LinhaSwitch>
            <S.GrupoInput>
              <S.InputLabel for="flAtivo">
                {flAtivo ? 'Ativo' : 'Inativo'}
              </S.InputLabel>
              <Switch
                aria-label="flAtivo"
                id="flAtivo"
                name="flAtivo"
                checked={flAtivo}
                ref={register}
                onChange={handleSwitchChange}
              />
            </S.GrupoInput>
            <S.MotivoBloqueio usuarioBloqueio={mudarBorderRadius}>
              {flAtivo ? (
                'Usuário ativo'
              ) : (
                <>
                  Motivo da inatividade:{' '}
                  <strong> {bloqueioMotivoUpdated}</strong>
                </>
              )}
            </S.MotivoBloqueio>
          </S.LinhaSwitch>
          <S.Divisor />
          <S.Linha>
            <S.LabelDefault>
              Usuário vendedor:{' '}
              <S.Span isVendedor={isVendedor}>
                {isVendedor ? 'Sim' : 'Não'}
              </S.Span>
            </S.LabelDefault>
            <></>
          </S.Linha>
          <S.Permissoes>
            <Checkbox
              disabled={!isVendedor}
              id="receberEmails"
              label="Liberar recebimento de e-mails."
              checked={permissoes.receberEmails}
              onChange={(event) =>
                handleChange(event.currentTarget.checked, 'receberEmails')
              }
            />
            <Checkbox
              disabled={!isVendedor}
              id="visualizarTodosClientes"
              label="Liberar visualização de todos os clientes."
              checked={permissoes.visualizarTodosClientes}
              onChange={(event) =>
                handleChange(
                  event.currentTarget.checked,
                  'visualizarTodosClientes'
                )
              }
            />
          </S.Permissoes>
          <S.Divisor />
          <S.CheckboxEnviarSmsForaParqueWrapper>
            <Checkbox
              id="liberarEnviarSmsForaParque"
              label="Liberar envio de SMS para linhas fora do parque do cliente."
              checked={permissoes.enviarSmsForaParque}
              onChange={(event) =>
                handleChange(event.currentTarget.checked, 'enviarSmsForaParque')
              }
            />
          </S.CheckboxEnviarSmsForaParqueWrapper>
          <S.Divisor />
          <S.Linha>
            <S.GrupoInput>
              <S.InputLabel for="dsSenha">Senha</S.InputLabel>
              <S.InputWrapper>
                <S.Input
                  autoComplete="off"
                  type={mostrarSenha}
                  disabled
                  placeholder="Insira a senha"
                  id="dsSenha"
                  name="dsSenha"
                  ref={register}
                />
                <S.BotaoVerSenha type="button" onClick={handleVerSenha}>
                  {exibirIcone}
                </S.BotaoVerSenha>
              </S.InputWrapper>
            </S.GrupoInput>
            <S.BotaoGerarSenha type="button" onClick={handleGerarSenha}>
              <img alt="gerar_senha" src={iconeGerarSenha} />
              GERAR SENHA
            </S.BotaoGerarSenha>
          </S.Linha>
          <S.Divisor />
          <S.BotoesWrapper>
            <S.BotaoCancelar onClick={() => handleCancelar()}>
              CANCELAR
            </S.BotaoCancelar>
            <S.BotaoConfirmar disabled={!habilitarConfirmar} type="submit">
              CONFIRMAR
            </S.BotaoConfirmar>
          </S.BotoesWrapper>
        </S.Form>
        {revelarMensagemSucesso && (
          <div className="componente-modal-overlay">
            <div className="componente-modal">
              <MensagemSucesso
                handleMensagemSucesso={handleMensagemSucesso}
                mensagemTitulo="Sucesso"
                mensagemParagrafo1={`Usuário ${dsUsuario} ${phMensagemSucesso}.`}
                mensagemBotao="Continuar"
              />
            </div>
          </div>
        )}
        {revelarMensagemErro && (
          <div className="componente-modal-overlay">
            <div className="componente-modal">
              <MensagemErro
                handleMensagemErro={handleMensagemErro}
                mensagemTitulo="Erro!"
                mensagemParagrafo1={mensagemErro}
                mensagemBotao="Retornar"
              />
            </div>
          </div>
        )}
      </S.Modal>
    </S.Overalay>
  )
}
